import { findIndex } from "lodash";
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: "",
  held: false,
  inScene: true,
  solution: null,
  lidId: -1,
  hasSolution: false,
  tooltipLabel: '',
  hideControls: false
};

export function CuvetteReducer(
  state = { cuvettes: [] },
  action
) {
  let currentCuvette;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (
    action.type !== "CREATE_CUVETTE" &&
    !action.type.includes("@redux")
  ) {
    if (action.payload.hasOwnProperty("id")) {
      if (
        state.protocolSection.scene.apparatus.hasOwnProperty("cuvettes")
      ) {
        currentCuvette =
          state.protocolSection.scene.apparatus.cuvettes[
            findIndex(state.protocolSection.scene.apparatus.cuvettes, {
              id: action.payload.id,
            })
          ];
      }
    }
  }

  switch (action.type) {
    case "CREATE_CUVETTE":
      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props };

      if (protocolSection.scene.apparatus.hasOwnProperty("cuvettes")) {
        protocolSection.scene.apparatus.cuvettes = [
          ...protocolSection.scene.apparatus.cuvettes,
          newObj,
        ];
      } else {
        protocolSection.scene.apparatus.cuvettes = [newObj];
      }

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };

    case "SET_CUVETTE_SOLUTION":
      currentCuvette = state.protocolSection.scene.apparatus.cuvettes[action.payload.id-1];
      currentCuvette.solution = action.payload.solution;
      //currentCuvette.tooltipLabel = "Cuvette " + action.payload.solutionAlias;
      currentCuvette.hasSolution = true;

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };

    case "CUVETTE_DROP_ITEM":
      //Create new obj from template state
      // let newObj = { ...templateState, ...action.payload.props };

      currentCuvette = state.protocolSection.scene.apparatus.cuvettes[action.payload.cuvetteId-1];
      switch(action.payload.type){
        case "cuvetteSeal":
          currentCuvette.lidId = action.payload.sealId;
          break;
      }

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };

    case "CUVETTE_REMOVE_ITEM":
      //Create new obj from template state
      // let newObj = { ...templateState, ...action.payload.props };

      currentCuvette = state.protocolSection.scene.apparatus.cuvettes[action.payload.id-1];
      switch(action.payload.type){
        case "lid":
          currentCuvette.lidId = -1;
          break;
        case "solution":
          currentCuvette.solution = null;
          currentCuvette.tooltipLabel = "Empty cuvette " + currentCuvette.id -1;
          break;
      }


      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };

       case 'SET_CUVETTE_HELD':

      currentCuvette.held = action.payload.held
      protocolSection.scene.apparatus.cuvettes[findIndex(state.cuvettes, { id: action.payload.id })] = currentCuvette

      return { ...state, ...{
        protocolSection: protocolSection
      } }
      case "SET_CUVETTE_CONTROLS_VISIBLE":
        // Make the current gels controls visible
        currentCuvette = state.protocolSection.scene.apparatus.cuvettes;
        currentCuvette.forEach(cuvette => {
          cuvette.controlsVisible = false;
        });
        protocolSection.scene.apparatus.cuvettes = currentCuvette

        currentCuvette.controlsVisible = action.payload.controlsVisible;

        protocolSection.scene.apparatus.cuvettes[findIndex(state.gels, { id: action.payload.id })] = currentCuvette;
        return { ...state, ...{ protocolSection: protocolSection } };


      case "SET_CUVETTE_IN_SCENE":
        //Payload = {inScene}
        currentCuvette.inScene = action.payload.inScene;
        protocolSection.scene.apparatus.cuvettes[findIndex(state.protocolSection.scene.apparatus.cuvettes, { id: action.payload.id })] = currentCuvette;
        return { ...state, ...{ protocolSection: protocolSection } };

    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('cuvettes')) {
        protocolSection.scene.apparatus.cuvettes =
          action.payload.lastState.scene.apparatus.cuvettes;

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };
      } else {
        return state;
      }

    default:
      return state;
  }
}
